export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--9-2!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticSocialNews.vue?vue&type=style&index=0&id=56dd1b5b&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-social-news/VuesticSocialNews.vue?vue&type=style&index=0&id=56dd1b5b&prod&lang=scss
// module id = w8dD
// module chunks = 41